import { createAction } from '@reduxjs/toolkit';
export const FORWARD_VOICEMAIL = 'FORWARD_VOICEMAIL';
export const forwardVoicemailAction = createAction(FORWARD_VOICEMAIL);
